import React from 'react';
import Chatbutton from '../components/chatbutton'
import Carousell from '../components/carousel';
import FooterBar from '../components/FooterBar';
import '../styles/chatbutton.css'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import 'react-notifications/lib/notifications.css';
class HomeScreen extends React.Component {
  constructor() {
    super()
  }

  render() {
    return (
      
      
      <section className=" ">
        <Carousell/>
         <div className="container container-lg container-fluid my-5 py-5">
           
          
          <p className='popular h3 text text-dark'><i class="bi bi-fire"></i>&nbsp;Our Most Popular Keyboards&nbsp;<i class="bi bi-fire"></i></p>
          <div id="popular-product">
            <div id="post">
              <div className="container-fluidx">
                <div className="card" style={{ width: 'auto' }} id="product-list">
                </div>
                <div className="card" id="cardproduct"><br />
                  <div className="card-body">
                    <img className="card-img w-100 h-100 rounded" src="images/kb1.png" />
                    <p className="productname h4 text text-dark">QK65</p>
                    <p className='productbrand text text-dark'>Keeb</p>
                    <p className='productprice h2 text text-dark'>$100</p>
                    <a href="SingleProduct?productid=39" className="stretched-link" /></div>
                </div>
                <div className="card" id="cardproduct"><br />
                  <div className="card-body">
                    <img className="card-img w-100 h-100 rounded" src="images/kb2.png" />
                    <p className="productname h4 text text-dark">GK61</p>
                    <p className='productbrand text text-dark'>Keeb</p>
                    <p className='productprice h2 text text-dark'>$150</p>
                    <a href="SingleProduct?productid=40" className="stretched-link" /></div>
                </div>
                <div className="card" id="cardproduct"><br />
                  <div className="card-body">
                    <img className="card-img w-100 h-100 rounded" src="images/kb3.png" />
                    <p className="productname h4 text text-dark">RK61</p>
                    <p className='productbrand text text-dark'>Keeb</p>
                    <p className='productprice h2 text text-dark'>$150</p>
                    <a href="SingleProduct?productid=41" className="stretched-link" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="container p-sm-5 p-2 mb-5  ">
          <div style={{ width: '100%' }}><iframe width="100%" height="769vh" src="https://www.youtube.com/embed/Rd2lxQo2pV4" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
          </div></section>
        <Chatbutton ></Chatbutton>
        <NotificationContainer />
        <FooterBar/>
      </section>


    );
  }

}


export default HomeScreen;